import { uiController } from '@/controllers/uiController'
import { Modal } from 'antd'
import { observer } from 'mobx-react'
import { FC } from 'react'
import { BuyTokenPackageDialog } from '../BuyTokenPackageDialog'
import { BuyVipDialogV1 } from '../BuyVipDialogV1'
import ExchangeCodeDialog from '../ExchangeCodeDialog/ExchangeCodeDialog'
import { PaySuccessDialog } from '../PaySuccessDialog'
import { PaySuccessEducationDiaLog } from '../PaySuccessEducationDiaLog'
import PdfUpgradeModal from '../PdfUpgradeModal/PdfUpgradeModal'
import style from './CommonDialogLayout.module.less'
import { userService } from '@/services/userService'

interface CommonDialogLayoutProps {}

const CommonDialogLayout: FC<CommonDialogLayoutProps> = observer(
  (props: CommonDialogLayoutProps) => {
    return (
      <div>
        {/* 支付成功弹窗 */}
        <PaySuccessDialog
          onClose={() => {
            uiController.paySuccessDialogProps = { open: false }
            userService.invokePaySuccessfulListener()
          }}
          {...uiController.paySuccessDialogProps}
        ></PaySuccessDialog>
        {/* 教育优惠支付成功弹窗 */}
        <PaySuccessEducationDiaLog 
          {...uiController.paySuccessEducationDialogProps} 
          onClose={() => {
            uiController.paySuccessEducationDialogProps = { open: false }
          }}
        >

        </PaySuccessEducationDiaLog>

        {/* 加量包购买弹窗 */}
        {uiController.buyTokenPackageDialogProps.open && (
          <BuyTokenPackageDialog
            paySuccess={() => {
              // 支付成功
              uiController.paySuccessDialogProps = {
                open: true,
                enableGiftReceiveBtn: false,
              }
            }}
            onClose={(isPaySuccessful) => {
              uiController.buyTokenPackageDialogProps = { open: false }
              if (!isPaySuccessful) {
                // 用户点击关闭
                userService.closePayModalListener?.()
              }
            }}
            {...uiController.buyTokenPackageDialogProps}
          ></BuyTokenPackageDialog>
        )}

        {/* 新版本支付弹窗，仅会员购买 */}
        {uiController.buyVipDialogV1Props.open && (
          <BuyVipDialogV1
            onClose={(isPaySuccessful) => {
              uiController.buyVipDialogV1Props = { open: false }
              if (!isPaySuccessful) {
                // 用户点击关闭
                userService.closePayModalListener?.()
              }
            }}
            paySuccess={(enableReceiveGift) => {
              // 支付成功
              uiController.paySuccessDialogProps = {
                open: true,
                enableGiftReceiveBtn: enableReceiveGift,
              }
            }}
            {...uiController.buyVipDialogV1Props}
          ></BuyVipDialogV1>
        )}
        {/* 通用提示弹窗 */}
        <Modal className={style.commonModal} centered {...uiController.commonModalProps}>
          {uiController.commonModalProps.content}
        </Modal>

        {uiController.exchangeDialogProps.open && (
          <ExchangeCodeDialog
            {...uiController.exchangeDialogProps}
            onClose={() => {
              uiController.exchangeDialogProps = { open: false }
            }}
          ></ExchangeCodeDialog>
        )}
      </div>
    )
  }
)

export default CommonDialogLayout
